import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ArrowRight, Shield, Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { DashboardCarousel } from './DashboardCarousel';

export function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative overflow-hidden py-20 md:py-32">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/5 via-background to-background" />
      
      <div className="container mx-auto px-4 max-w-7xl relative">
        <div className="mx-auto max-w-4xl text-center space-y-8">
          {/* Badge */}
          <Badge variant="secondary" className="gap-2">
            <Sparkles className="h-3 w-3" />
            Nova versão disponível
          </Badge>

          {/* Headline */}
          <h1 className="text-4xl md:text-6xl font-bold tracking-tight">
            Gestão inteligente de{' '}
            <span className="text-primary">Métricas SaaS</span>
            {' '}e de Produtos Digitais
          </h1>

          {/* Subheadline */}
          <p className="text-xl md:text-2xl text-muted-foreground max-w-3xl mx-auto">
            Acompanhe MRR, ARR, Churn e mais de 15 métricas em um único dashboard poderoso
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <Button
              size="lg"
              onClick={() => navigate('/auth?signup=true')}
              className="gap-2"
            >
              Começar Teste Grátis
              <ArrowRight className="h-4 w-4" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Ver Planos
            </Button>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-6 pt-8 text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              <Shield className="h-4 w-4 text-green-500" />
              Sem cartão de crédito
            </div>
            <div className="flex items-center gap-2">
              <Shield className="h-4 w-4 text-green-500" />
              Cancelamento gratuito
            </div>
            <div className="flex items-center gap-2">
              <Shield className="h-4 w-4 text-green-500" />
              Suporte em português
            </div>
          </div>

          {/* Dashboard Carousel */}
          <div className="pt-12">
            <DashboardCarousel />
          </div>
        </div>
      </div>
    </section>
  );
}
